"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ceil = exports.LAND = void 0;
exports.createMeasurementsStrings = createMeasurementsStrings;
exports.createPriceString = createPriceString;
exports.describeParking = describeParking;
exports.extractPrice = extractPrice;
exports.formatMeasurements = exports.floor = void 0;
exports.formatNumber = formatNumber;
exports.formatPrice = void 0;
exports.normalizeMeasurements = normalizeMeasurements;
exports.round = void 0;
exports.stringifyAddress = stringifyAddress;
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-float"));
var _epsilon = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/epsilon"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _time = require("@raywhite/helpers-utils/lib/helpers/time");
var _utils = require("./utils");
/**
 * Extract a numeric price out of a price string if possible.
 */
function extractPrice(price) {
  switch (true) {
    // Price-ish looking strings.
    case /^\$?[0-9,]+(\.[0-9]+)?$/.test(price):
      return (0, _parseFloat2.default)(price.toString().replace(/[^0-9.]/g, ''), 10);

    // Prices like 200k.
    case /^\$?[0-9]+[kK]$/.test(price):
      return (0, _parseFloat2.default)(price.toString().replace(/[^0-9.]/g, ''), 10) * 1000;

    // Prices like 1.2 million
    case /^\$?[0-9]+(\.[0-9]+)?(m|M|\s+million)$/.test(price):
      return (0, _parseFloat2.default)(price.toString().replace(/[^0-9.]/g, ''), 10) * 1000000;

    // Some string we can't detect.
    default:
      return undefined;
  }
}
var rounder = (fn, offset) => function (value) {
  var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var factor = 10 ** places;
  return fn((value + offset) * factor) / factor;
};

/**
 * Accurate rounding for JS.
 */
var round = exports.round = rounder(Math.round, _epsilon.default);
var floor = exports.floor = rounder(Math.floor, _epsilon.default);
var ceil = exports.ceil = rounder(Math.ceil, -_epsilon.default);

/**
 * Takes the `price` string provided in listings and
 * formats it in order to display something coherant.
 * Where we detect a price-like string (something
 * containing a set of digit chars) we can insert a
 * `$` and comma's where appropriate.
 *
 * @param {String} price
 * @param {String} prefix
 * @param {boolean} round
 *
 * @returns {String} price
 */
function formatNumber(price) {
  var _context, _context2;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var roundNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var digits = extractPrice(price);

  // Some string we can't detect.
  if (!digits) return price;
  var string = (roundNumber ? round(digits) : digits).toString();
  var [before, after] = string.split('.');
  var commad = before.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // eslint-disable-next-line prefer-template
  return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(prefix)).call(_context2, commad)).call(_context, after ? '.' + after : '');
}
var formatPrice = price => formatNumber(price, '$');
exports.formatPrice = formatPrice;
function deadlinePrice(price, defaultLabel, eventDate) {
  var _context3, _context4, _context5;
  var {
    date,
    month
  } = (0, _time.createTime)(eventDate);
  var deadline = (0, _concat.default)(_context3 = "- ".concat(date, " ")).call(_context3, (0, _slice.default)(month).call(month, 0, 3));
  return price ? (0, _concat.default)(_context4 = "".concat(price, " ")).call(_context4, deadline) : (0, _concat.default)(_context5 = "".concat(defaultLabel, " ")).call(_context5, deadline);
}

/**
 * Dealing with all of the different permutations of possible
 * price types is incredibly awkward, so it's worth having
 * a dedicated parsing func for these - and given the number
 * of values that we are dealing with we might as well just
 * pass the entire listing through.
 *
 * @param {Object} listing
 *
 * @returns {String} price string
 */
function createPriceString(listing) {
  var _context6, _context7, _context8, _context9;
  var expandedString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var {
    bond: _bond,
    displayPrice,
    rentFrequency,
    rentPrice,
    setSaleDate,
    soldDate,
    soldPrice,
    status,
    statusCode,
    subTypeCode,
    tenderDate
  } = listing;
  var price = '';
  var priceFrequency = '';
  var bond = '';

  // Current properties.
  if (statusCode === 'CUR') {
    price = displayPrice || rentPrice ? formatPrice(displayPrice || rentPrice) : '';

    // Rental price frequency, only add if price is numeric and it's not a BOTH subtype listing
    priceFrequency = subTypeCode !== 'BOTH' && rentFrequency && /^\$?[0-9,.]+(\s*-\s*\$?[0-9,.]+)?$/.test(price) ? rentFrequency : '';

    // Rental bond.
    bond = _bond && expandedString && "/ ".concat(formatPrice(_bond), " Bond");
    if (setSaleDate) price = deadlinePrice(price, 'Deadline Sale', setSaleDate);
    if (tenderDate) price = deadlinePrice(price, 'Tender Sale', tenderDate);

    // Fallback where we've got no price.
    if (!price) price = 'Enquiries Welcome';
  }

  // Sold properties.
  if (statusCode === 'SLD') {
    price = soldPrice && expandedString ? "Sold for ".concat(formatPrice(soldPrice)) : status;
  }

  // Leased properties.
  if (statusCode === 'LSE') {
    price = status;
  }

  // Sold date.
  var soldTime = soldDate ? (0, _time.createTime)(soldDate) : null;
  var soldDateString = soldTime ? (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "on ".concat(soldTime.date, " ")).call(_context7, (0, _slice.default)(_context8 = soldTime.month).call(_context8, 0, 3), " ")).call(_context6, soldTime.year) : '';
  return (0, _filter.default)(_context9 = [price, soldDateString, priceFrequency, bond]).call(_context9, v => v).join(' ');
}

/**
 * Gets measurements while also converting format for appropriate display.
 *
 * Building sizes are always in square metres, while land sizes can be in acres
 * (LAA), hecatres (LAH) and square meters (LAS). We generally want to show
 * the land size in both imperial and metric, but pick hectares for large values
 * and sqm for small.
 *
 * Note also that building sizes may be specified as a range, not as a single
 * value; this is often used for commercial where a single listing comprises
 * multiple buildings/offices etc.
 *
 * @param {Array} measurements The raw listing measurements.
 *
 * @return {Object} Measurements keyed by measurement code.
 */
function normalizeMeasurements() {
  var measurements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var res = {
    building: {
      value: undefined,
      minimum: undefined,
      maximum: undefined
    },
    land: {
      metres: undefined,
      acres: undefined,
      hectares: undefined
    }
  };
  var hectaresDecimalThreshold = 10;
  var acresDecimalThreshold = 25;
  (0, _forEach.default)(measurements).call(measurements, measure => {
    var {
      code,
      maximum,
      minimum,
      value
    } = measure;
    var _squareMetersToAcres = round(value / 4046.86, 2);
    var _squareMetersToHectares = round(value / 10000, 4);
    var _hectaresToMeters = round(value * 10000);
    var _hectaresToAcres = round(value * 10000 / 4046.86, 2);
    var _acresToMeters = round(value * 4046.86);
    var _acresToHectares = round(_acresToMeters / 10000, 4);
    switch (code) {
      case 'BAS':
        // Buidling, square metres.
        res.building.value = value;
        res.building.minimum = minimum;
        res.building.maximum = maximum;
        break;
      case 'LAS':
        // Land, square metres.
        res.land.metres = value;
        res.land.acres = _squareMetersToAcres < acresDecimalThreshold ? _squareMetersToAcres : round(_squareMetersToAcres);
        res.land.hectares = _squareMetersToHectares < hectaresDecimalThreshold ? _squareMetersToHectares : round(_squareMetersToHectares);
        break;
      case 'LAH':
        // Land, hectares.
        res.land.metres = _hectaresToMeters;
        res.land.acres = _hectaresToAcres < acresDecimalThreshold ? _hectaresToAcres : round(_hectaresToAcres);
        res.land.hectares = value < hectaresDecimalThreshold ? value : round(value);
        break;
      case 'LAA':
        // Land, acres.
        res.land.acres = value < acresDecimalThreshold ? value : round(value);
        res.land.metres = _acresToMeters;
        res.land.hectares = _acresToHectares < hectaresDecimalThreshold ? _acresToHectares : round(_acresToHectares);
        break;
      default:
        throw new Error("Unknown measurement type \"".concat(code, "\"."));
    }
  });
  return res;
}
var COMBINED = '@@MEASUREMENTS/COMBINED';
var BUILDING = '@@MEASUREMENTS/BUIDLING';
var LAND = exports.LAND = '@@MEASUREMENTS/LAND';

/**
 * Given an array of measurements for building and land sizes.
 * It returns an array of formated strings, suitable for listings
 * cards etc.
 *
 * @param {Array} measurements - the array of measurements.
 *
 * @returns {Array}
 */
function createMeasurementsStrings(measurements) {
  var {
    minAcres = 0
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  if (!measurements.length) return ret;
  var f = n => formatNumber(n, '', false);
  var {
    building: {
      maximum,
      minimum,
      value
    },
    land: {
      acres,
      hectares,
      metres
    }
  } = normalizeMeasurements(measurements);
  var facres = acres && acres >= minAcres ? " (".concat(f(acres), " acres)") : '';
  if (value && metres && value === metres) {
    var _context10;
    ret.push({
      type: COMBINED,
      value: (0, _concat.default)(_context10 = "Building/Land: ".concat(f(value), "m\xB2")).call(_context10, facres)
    });
    return ret;
  }

  // eslint-disable-next-line func-names
  ;
  (function () {
    if (minimum) {
      var _context11;
      ret.push({
        type: BUILDING,
        value: (0, _concat.default)(_context11 = "Building: ".concat(f(minimum), "-")).call(_context11, f(maximum), "m\xB2")
      });
      return;
    }
    if (value) {
      ret.push({
        type: BUILDING,
        value: "Building: ".concat(f(value), "m\xB2")
      });
    }
  })();
  if (hectares) {
    var _context12, _context13;
    ret.push({
      type: LAND,
      value: hectares < 1 ? (0, _concat.default)(_context12 = "Land: ".concat(f(metres), "m\xB2")).call(_context12, facres) : (0, _concat.default)(_context13 = "Land: ".concat(f(hectares), " ha")).call(_context13, facres)
    });
  }
  return ret;
}
var formatMeasurements = measurements => {
  var _context14;
  if (!measurements.length) return null;
  var {
    building: {
      maximum,
      minimum,
      value
    },
    land: {
      acres,
      hectares,
      metres
    }
  } = normalizeMeasurements(measurements);
  var f = n => formatNumber(n, '', false);
  var _building;
  var _land;
  if (minimum && maximum) _building = (0, _concat.default)(_context14 = "".concat(f(minimum), " - ")).call(_context14, f(maximum), "m\xB2");
  if (value) _building = "".concat(f(value), "m\xB2");
  if (metres) {
    var _context15, _context16;
    _land = hectares > 1 ? (0, _concat.default)(_context15 = "".concat(f(hectares), " ha / ")).call(_context15, f(acres), " acres") : _land = (0, _concat.default)(_context16 = "".concat(f(metres), "m\xB2 / ")).call(_context16, f(acres), " acres");
  }
  var result = [];
  if (_building) result.push({
    label: 'Building',
    value: _building
  });
  if (_land) result.push({
    label: 'Land',
    value: _land
  });
  return result;
};
exports.formatMeasurements = formatMeasurements;
var noEmpty = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return (0, _filter.default)(args).call(args, arg => !!arg);
};
function stringifyAddress(address) {
  var _context18;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    lotNumber,
    postCode,
    state,
    stateCode,
    streetName: _streetName,
    streetNumber: _streetNumber,
    streetType,
    suburb,
    unitNumber
  } = address;
  var {
    suburbFallback = true,
    withLocality = false,
    withPostCode = false,
    withState = false,
    withStreet = true
  } = options;
  var suburbAddress = noEmpty(suburb ? noEmpty(suburb, withState && ',').join('') : undefined, withState && (stateCode || state), withPostCode && postCode).join(' ');
  if (!withStreet) return suburbAddress;

  // Workaround for address data where the number is in the street name (WTF).
  var streetName;
  var streetNumber;
  var pattern = /^([0-9]+(?:\s*-\s*[0-9]+)?)\s+/;
  if (!_streetNumber && pattern.test(_streetName)) {
    streetNumber = _streetName.match(pattern)[1];
    streetName = _streetName.replace(pattern, '');
  } else {
    streetName = _streetName;
    streetNumber = _streetNumber || '';
  }

  // Addresses without any street level data are private and should return locality info instead
  if (!(lotNumber || unitNumber || streetNumber || streetName || streetType)) {
    return suburbFallback ? suburbAddress : '';
  }
  var number = (unitNum, streetNum) => {
    var _context17;
    return (0, _filter.default)(_context17 = [unitNum, streetNum]).call(_context17, Boolean).join('/');
  };
  var streetAddress = noEmpty(!lotNumber || /^lot/i.test(lotNumber) ? lotNumber : "Lot ".concat(lotNumber), number(unitNumber, streetNumber), streetName, streetType).join(' ');
  return withLocality ? (0, _concat.default)(_context18 = "".concat(streetAddress, ", ")).call(_context18, suburbAddress) : streetAddress;
}
function describeParking(garages, openSpaces, carports, carParkingDetails) {
  var _context19, _context20, _context21, _context22, _context23;
  if (!(garages || openSpaces || carports || carParkingDetails)) {
    return undefined;
  }
  if (carParkingDetails) {
    return carParkingDetails;
  }
  var fields = (0, _filter.default)(_context19 = [garages && (0, _concat.default)(_context20 = "".concat(garages, " ")).call(_context20, (0, _utils.pluralize)(garages, 'garage space', 'garage spaces')), carports && (0, _concat.default)(_context21 = "".concat(carports, " ")).call(_context21, (0, _utils.pluralize)(carports, 'carport space', 'carport spaces')), openSpaces && (0, _concat.default)(_context22 = "".concat(openSpaces, " ")).call(_context22, (0, _utils.pluralize)(openSpaces, 'off street park', 'off street parks'))]).call(_context19, x => !!x);
  return (0, _filter.default)(_context23 = [(0, _slice.default)(fields).call(fields, 0, -1).join(', '), (0, _slice.default)(fields).call(fields, -1)[0]]).call(_context23, x => !!x).join(' and ');
}